




import Vue from "vue";
import Component from "vue-class-component";
import { UserStore } from "@/store";
import router, { ROUTES } from "@/router";

@Component
export default class LandingPage extends Vue {
  private companyId: string = "";

  async created() {
    this.companyId = this.$route.params.companyid;
    await UserStore.LoadCompanyDetails(this.companyId);

    if (this.$route.query.redirect) {
      router.push("/" + this.$route.query.redirect.toString());
    } else {
      router.push({ name: ROUTES.home });
    }
  }
}
